import React from "react";
import "./BestAndWorstLegend.scss";
import { currencyFormatter } from "../../../MMM/MMMUtils";

export const colorsWorst = [
  "#FF2630FF",
  "#FF2630FF",
  "#FF2630CC",
  "#FF2630B3",
  "#FF263099",
  "#FF263080",
  "#FF263066",
  "#FF26304D",
  "#FF263033",
  "#FF26301A",
];

export const colorsBest = [
  "#0194FFFF",
  "#0194FFE6",
  "#0194FFCC",
  "#0194FFB3",
  "#0194FF99",
  "#0194FF80",
  "#0194FF66",
  "#0194FF4D",
  "#0194FF33",
  "#0194FF1A",
];

interface GeoRankMap {
  [geo: string]: {
    rank: number;
    dma: string;
    incrementalOutcome: number;
    spend: number;
    response: number;
  };
}

interface BestAndWorstLegendProps {
  label: string;
  data: GeoRankMap;
  dataFormatter: (value: number) => string;
  geoNames: { [dma: string]: string };
  isBest: boolean;
}

const BestAndWorstLegend: React.FC<BestAndWorstLegendProps> = ({
  label,
  data,
  dataFormatter,
  isBest,
  geoNames,
}) => {
  const colors = isBest ? colorsBest : colorsWorst;

  const items = Object.values(data);

  items.sort((a, b) => a.rank - b.rank);

  return (
    <div className="responseTable">
      <div className="responseHeader">
        <div className="colCity">{isBest ? `Best ${label}` : `Worst ${label}`}</div>
        <div className="colResponse">{label}</div>
        <div className="colSpend">Spend</div>
      </div>

      {items.map((item, i) => {
        const bg = colors[i];
        return (
          <div className="responseRow" key={item.dma}>
            <div className="colCity">
              <span className="rankIcon" style={{ backgroundColor: bg }} />
              <span>
                {i + 1}. {geoNames[item.dma]}
              </span>
            </div>
            <div className="colResponse">{dataFormatter(item.response)}</div>
            <div className="colSpend">{currencyFormatter.format(item.spend, 0)}</div>
          </div>
        );
      })}
    </div>
  );
};

export default BestAndWorstLegend;
